export default function IosSpeedometerOutline() {
  return (
    <div
      className="ion-icon-ios-speedometer-outline"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M256,64C132.288,64,32,164.226,32,287.938c0,56.975,21.283,108.97,56.316,148.5c3.551,4.006,7.241,7.82,11.066,11.562
		c3.059-3.49,6.232-6.834,9.539-10.141c0.48-0.48,0.972-0.947,1.456-1.422c18.78-18.426,40.521-32.949,64.664-43.161
		c25.633-10.842,52.871-16.339,80.958-16.339s55.325,5.497,80.958,16.339c24.144,10.212,45.884,24.735,64.664,43.161
		c0.484,0.475,0.976,0.941,1.456,1.422c3.307,3.307,6.48,6.65,9.539,10.141c3.825-3.742,7.516-7.557,11.066-11.562
		c35.033-39.53,56.316-91.525,56.316-148.5C480,164.226,379.712,64,256,64z M447.661,369.177
		c-8.663,20.481-20.429,39.092-35.044,55.776c-40.39-39.51-95.653-63.945-156.617-63.945s-116.228,24.33-156.617,63.84
		c-14.615-16.685-26.381-35.172-35.044-55.653c-9.81-23.19-15.228-47.694-16.173-72.694H79.5v-16H48.166
		c0.945-25,6.363-50.048,16.173-73.239c9.372-22.157,22.376-42.431,38.692-60.11l26.932,26.893l5.496-5.538l5.277-5.264l-0.02-0.027
		l0.547-0.552l-26.951-26.984c17.862-16.647,38.004-29.894,60.479-39.4c23.191-9.81,47.708-15.229,72.708-16.174V117.5h16V80.104
		c26,0.945,50.017,6.363,73.208,16.173c22.437,9.49,42.921,22.706,60.762,39.312l-26.975,27.069l0.577,0.547l-0.004,0.019
		l5.285,5.246l5.5,5.503l27.026-27.057c16.356,17.703,29.392,38.148,38.78,60.345c9.81,23.191,15.229,48.239,16.174,73.239H431.5v16
		h32.334C462.889,321.5,457.471,345.986,447.661,369.177z"/>
	<path d="M368.479,174.545l-85.484,73.727c-7.697-5.255-16.992-8.334-26.994-8.334c-26.467,0-48,21.533-48,48
		c0,10.479,3.385,20.178,9.106,28.08l-11.948,11.948l11.312,11.313l12.033-12.033c7.795,5.469,17.273,8.691,27.496,8.691
		c26.467,0,48-21.533,48-48c0-10.387-3.327-20.005-8.956-27.868l74.849-84.11L368.479,174.545z M256,319.938
		c-17.673,0-32-14.326-32-32c0-17.673,14.327-32,32-32s32,14.327,32,32C288,305.611,273.673,319.938,256,319.938z"/>
</g>
</svg>
`,
      }}
    />
  )
}
